jQuery(document).ready(function ($) {  
 
  function updateVariantPrices(currentId) {
    const $matchedOption = $('select.variants_data option[value="' + currentId + '"]');

    if ($matchedOption.length === 0) {
      console.log("❌ No matching option found for variant:", currentId);
      return;
    }

    const variantTitle = $matchedOption.attr("title") || $matchedOption.text().trim();
    const variantPrice = $matchedOption.attr("data-price") || "";
    const currency = $('select.variants_data').attr('currentcy') || '$ ';

    if (variantTitle.includes("VIP Price")) {
      var guestTitle = variantTitle.replace("VIP Price", "Guest Price").trim();

      var $guestOption = $('select.variants_data option').filter(function() {
        return $(this).attr('title') === guestTitle;
      });

      if ($guestOption.length > 0) {
        var guestVariantPrice = $guestOption.attr('data-price');
        $('.vip_add_to_cart span.vip').text(variantPrice);
        $('.guest_add_to_cart span.guest').text(guestVariantPrice);    
      } else {
        console.warn("⚠️ No Guest variant found for:", guestTitle);
      }

    } else if (variantTitle.includes("Guest Price")) {
      var vipTitle = variantTitle.replace("Guest Price", "VIP Price").trim();

      var $vipOption = $('select.variants_data option').filter(function() {
        return $(this).attr('title') === vipTitle;
      });

      if ($vipOption.length > 0) {
        var vipVariantPrice = $vipOption.attr('data-price');
        $('.vip_add_to_cart span.vip').text(vipVariantPrice);
        $('.guest_add_to_cart span.guest').text(variantPrice);  
      } else {
        console.warn("⚠️ No VIP variant found for:", vipTitle);
      }            
    }
  }

  var checkVariant = setInterval(function () {
    var $variantInput = $("select.variants_data");

    if ($variantInput.length && $variantInput.val()) {
      clearInterval(checkVariant);
      var currentId = $variantInput.val();
      updateVariantPrices(currentId);
    }

  }, 500);

  document.addEventListener("variant:change", function (e) {
    if (!e.detail || !e.detail.variant) return;
    const currentId = e.detail.variant.id;
    updateVariantPrices(currentId);
  });

});
